module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "detail container",
    class: {
      area: _vm.area, fullscreen: _vm.fullscreen
    }
  }, [(!_vm.fullscreen) ? _c('section', {
    staticClass: "left panel"
  }, [_c('div', {
    staticClass: "wikis"
  }, [_c('h3', {
    staticClass: "header"
  }, [_vm._v("Wiki")]), _vm._v(" "), _c('wiki-selector', {
    attrs: {
      "wiki": _vm.wiki,
      "single": "false"
    },
    on: {
      "wiki": _vm.wikiSelected
    }
  }), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.addAnotherWiki($event)
      }
    }
  }, [_vm._v("Add another Wiki")])]), _vm._m(0), _vm._v(" "), _c('p')], 1), _vm._v(" "), _c('div', {
    staticClass: "ui clearing divider"
  }), _vm._v(" "), _c('h3', {
    staticClass: "header"
  }, [_vm._v("Metrics")]), _vm._v(" "), _vm._l((_vm.otherMetrics), function(o) {
    return _c('router-link', {
      key: o.name,
      staticClass: "ui line label",
      class: {
        active: o.name === _vm.metric
      },
      attrs: {
        "to": '/' + _vm.area + '/' + o.name
      }
    }, [_vm._v("\n            " + _vm._s(o.fullName) + "\n        ")])
  }), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.viewMoreMetrics($event)
      }
    }
  }, [_vm._v("View more metrics")])]), _vm._v(" "), (_vm.breakdowns) ? _c('div', [_c('div', {
    staticClass: "ui clearing divider"
  }), _vm._v(" "), _c('h3', {
    staticClass: "header"
  }, [_vm._v("Filters and Breakdowns")]), _vm._v(" "), _vm._l((_vm.breakdowns), function(b) {
    return _c('div', [_vm._v("\n                Show:\n                "), _vm._l((b.values), function(bv) {
      return _c('label', {
        staticClass: "xui checkbox"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (bv.on),
          expression: "bv.on"
        }],
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "checked": Array.isArray(bv.on) ? _vm._i(bv.on, null) > -1 : (bv.on)
        },
        on: {
          "__c": function($event) {
            var $$a = bv.on,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$c) {
                $$i < 0 && (bv.on = $$a.concat($$v))
              } else {
                $$i > -1 && (bv.on = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
              }
            } else {
              bv.on = $$c
            }
          }
        }
      }), _vm._v("\n                    " + _vm._s(bv.name) + "\n                ")])
    }), _vm._v(" "), _c('div', {
      staticClass: "ui toggle checkbox"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (b.on),
        expression: "b.on"
      }],
      attrs: {
        "type": "checkbox",
        "id": "breakdown"
      },
      domProps: {
        "checked": Array.isArray(b.on) ? _vm._i(b.on, null) > -1 : (b.on)
      },
      on: {
        "__c": function($event) {
          var $$a = b.on,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (b.on = $$a.concat($$v))
            } else {
              $$i > -1 && (b.on = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            b.on = $$c
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": "breakdown"
      }
    }, [_vm._v("\n                        Breakdown\n                        "), (!b.on) ? _c('span', [_vm._v("Off")]) : _vm._e(), _vm._v(" "), (b.on) ? _c('span', [_vm._v("On")]) : _vm._e(), _vm._v(" "), _c('i', {
      staticClass: "help circle icon",
      attrs: {
        "title": "Breakdowns help you see more detail by breaking down the total values into parts."
      }
    })])])], 2)
  })], 2) : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "graph panel"
  }, [_c('div', {
    staticClass: "ui clearing basic segment"
  }, [_c('h2', {
    staticClass: "ui left floated header"
  }, [_vm._v("\n                " + _vm._s(_vm.metricData.fullName || 'No data yet... ') + "\n                "), _c('span', {
    staticClass: "subdued"
  }, [_vm._v(_vm._s(_vm.wiki.replace(' (All languages)', '')))])]), _vm._v(" "), _c('div', {
    staticClass: "ui right floated basic fudge segment"
  }, [(_vm.chartType === 'bar') ? _c('simple-legend', {
    staticClass: "simple legend",
    attrs: {
      "data": _vm.metricData
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ui right floated icon buttons"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "ui simple dropdown right labeled icon button",
    attrs: {
      "title": "Change Chart"
    }
  }, [_c('i', {
    staticClass: "ui dropdown icon"
  }), _vm._v(" "), _c('span', [_c('i', {
    staticClass: "chart icon",
    class: _vm.chartIcon
  })]), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, _vm._l((_vm.chartTypes), function(t) {
    return _c('div', {
      key: t.chart,
      staticClass: "item",
      on: {
        "click": function($event) {
          _vm.changeChart(t)
        }
      }
    }, [_c('i', {
      staticClass: "chart icon",
      class: t.icon
    }), _vm._v("\n                                 " + _vm._s(t.chart) + "\n                             ")])
  }))])])], 1)]), _vm._v(" "), _c(_vm.chartComponent, {
    tag: "component",
    attrs: {
      "data": _vm.metricData,
      "breakdown": _vm.breakdown
    }
  }), _vm._v(" "), (_vm.metricData.type !== 'list') ? _c('div', {
    staticClass: "ui center aligned basic segment"
  }, [_c('time-range-selector'), _vm._v(" "), _c('h5', [_vm._v("\n                Total: " + _vm._s(_vm._f("kmb")(_vm.total)) + " " + _vm._s(_vm.metricData.fullName) + " "), _c('arrow-icon', {
    attrs: {
      "value": _vm.metricData.changeYoY
    }
  }), _vm._v(" " + _vm._s(_vm.metricData.changeYoY) + " "), _c('i', [_vm._v("this year")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ui center aligned subdued basic segment"
  }, [_c('p', [_vm._v("* Definition of " + _vm._s(_vm.metric) + " goes here, pulled from config or maybe dynamically from the wiki page.")]), _vm._v(" "), _c('p', [_vm._v("More descriptor text will go here assuming that it takes a few sentences to explain a term for a metric.")])]), _vm._v(" "), _c('div', {
    staticClass: "ui right floated icon button",
    on: {
      "click": _vm.toggleFullscreen
    }
  }, [_c('i', {
    staticClass: "ui icon",
    class: {
      expand: !_vm.fullscreen, compress: _vm.fullscreen
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "ui metrics modal"
  }, [_c('i', {
    staticClass: "close icon"
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "ui three column grid"
  }, _vm._l((_vm.areasWithMetrics), function(a) {
    return _c('div', {
      staticClass: "column"
    }, [_c('h4', {
      class: a.name,
      style: ({
        borderBottom: '2px solid ' + a.color
      })
    }, [_vm._v(_vm._s(a.name))]), _vm._v(" "), _vm._l((a.metrics), function(m) {
      return _c('div', {
        key: m.name,
        staticClass: "ui line label",
        class: {
          active: m.name === _vm.highlightMetric.name
        },
        on: {
          "click": function($event) {
            _vm.changeHighlight(m.name, a.name)
          }
        }
      }, [_vm._v("\n                    " + _vm._s(m.fullName) + "\n                ")])
    })], 2)
  })), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('div', {
    staticClass: "ui blue button",
    on: {
      "click": _vm.goHighlight
    }
  }, [_vm._v("Go")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "add wiki design"
  }, [_vm._v("\n                    \"Add another Wiki\" is not implemented in the prototype.  But you can see how it would work in "), _c('a', {
    attrs: {
      "target": "_new",
      "href": "https://www.dropbox.com/sh/lfrn4lcjyqhou7o/AAAmzec_63b1UwaZCGFDw1gea?dl=0&preview=Detail+Page+Two+Wiki+comparison.png"
    }
  }, [_vm._v("the design here")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "https://www.dropbox.com/sh/lfrn4lcjyqhou7o/AAAmzec_63b1UwaZCGFDw1gea?dl=0&preview=Wiki+Selector.png",
      "target": "_new"
    }
  }, [_vm._v("here")]), _vm._v(".\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "ui icon button",
    attrs: {
      "title": "Download"
    }
  }, [_c('i', {
    staticClass: "download icon"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_vm._v("\n            All Metrics\n            "), _c('div', {
    staticClass: "subdued"
  }, [_vm._v("Select a metric to visualize and explore its data")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-060f0676"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Detail.vue
// module id = 381
// module chunks = 1